import { FACTIONS } from '../content/factions';
import { defs } from '../content/registry';
import { MAPS } from '../content/map';

/** Stable ruleset identifier shared by the browser and authoritative server. */
export const PROTOCOL_VERSION = 3;

function fnv1a(input: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
}

export function contentHash(): string {
  const groups = Object.entries(defs)
    .filter(([, value]) => value instanceof Map)
    .map(([name, value]) => `${name}:${[...(value as Map<string, { id: string }>).keys()].sort().join(',')}`)
    .sort();
  const factions = Object.values(FACTIONS)
    .sort((a, b) => a.id.localeCompare(b.id))
    .map((f) => `${f.id}:${f.defaultDeck.join(',')}`);
  const maps = Object.values(MAPS).sort((a, b) => a.id.localeCompare(b.id)).map((map) => JSON.stringify(map));
  return `sigilfront-${fnv1a([...groups, ...factions, ...maps].join('|'))}`;
}
